import { FormT } from 'shared/types/model'
import moment from 'moment'

export const getFormLabel = (form: FormT) => {
  return (
    form.label || `Untitled (${moment(form.createdAt).format('MM-DD-YY LT')})`
  )
}
